<p-dialog [(visible)]="showclickedPic" [draggable]="false" (onHide)="closeDialogue()" [resizable]="false"
    [blockScroll]=true [modal]=true [modal]="true" [closeOnEscape]="false">
    <p-header class="row modal-header">
        <h5>
            <b>{{ picData?.picTitle }}</b>
        </h5>
    </p-header>
    <div class="modal-body col-sm-12">
        <div class="col-11" *ngFor="let pic of pics">
            <img src="data:image/jpeg;base64, {{pic}}" />
        </div>
    </div>
</p-dialog>